import { Theme, WithStyles } from "@material-ui/core";
import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import Grid from "@material-ui/core/Grid";
import { IStore } from "../store";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import Button from "@material-ui/core/Button";
import { ISubmitEvent } from "react-jsonschema-form";
import orange from "@material-ui/core/colors/orange";
import blue from "@material-ui/core/colors/blue";
import { MessageActions } from "../store/fcm";
import Paper from "@material-ui/core/Paper";
import { getApi } from "../api/ApiProvider";
import { Driver } from "../api/model";
import { BranchData } from "src/components/BranchSelector";

import { format } from "date-fns";
import { es } from "date-fns/locale";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  disableIcon: {
    color: orange[900],
  },
  editIcon: {
    color: blue[500],
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

export interface ReportData {
  driver: number;
  branch: number;
  init: string;
  end: string;
}

interface ReportProps extends WithStyles<keyof typeof classesType> {
  data: ReportData | any;
}

const reportSchema: JSONSchema6 = {
  title: "",
  type: "object",
  required: ["init", "end"],
  properties: {
    report: {
      type: "number",
      title: "Reporte",
      // anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      anyOf: [
        {
          type: "number",
          enum: [107121],
          title: "Lista de carreras por rango de fechas",
        },
      ],
      default: 107121,
      // default: 0,
    },
    init: { type: "string", title: "Fecha inicio", format: "date" },
    end: { type: "string", title: "Fecha fin", format: "date" },
    branch: {
      type: "number",
      title: "Sucursal",
      anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      default: 0,
    },
    driver: {
      type: "number",
      title: "Conductor",
      anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      default: 0,
    },
  },
  dependencies: {},
};

class ReportsPage extends React.Component<
  ReportProps,
  { data: any; schema: any }
> {
  static getDefaultEntity() {
    return { title: "", message: "", type: "topic", topicName: "driver" };
  }

  constructor(props: ReportProps) {
    super(props);
    this.state = { data: ReportsPage.getDefaultEntity(), schema: reportSchema };

    this.handleSubmit = this.handleSubmit.bind(this);

    getApi()
      .driver()
      .listActiveByAdmin()
      .then((data: Driver[]) => {
        const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(reportSchema));

        const driver = newSchema.properties!.driver as JSONSchema6;

        driver.anyOf = data.map((d) => {
          return {
            type: "number",
            enum: [d.id],
            title: d.branch.name + d.user.name || d.user.email || "",
          } as JSONSchema6;
        });

        driver.anyOf.splice(0, 0, {
          type: "number",
          enum: [0],
          title: "Todos",
        });

        this.setState({ schema: newSchema }, () => {
          this.fillBranchInSchema();
        });
      });
  }

  fillBranchInSchema() {
    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((dataB: BranchData[]) => {
        const newSchema2: JSONSchema6 = JSON.parse(
          JSON.stringify(this.state.schema)
        );
        const branch = newSchema2.properties!.branch as JSONSchema6;
        const report = newSchema2.properties!.report as JSONSchema6;

        branch.anyOf = dataB.map((d) => {
          return {
            type: "number",
            enum: [d.id],
            title: d.name || "",
          } as JSONSchema6;
        });

        branch.anyOf.splice(0, 0, {
          type: "number",
          enum: [0],
          title: "Todos",
        });

        // comentado temporalmente para que cualquier admin pueda imprimir reporte
        // getApi()
        //   .report()
        //   .reportList()
        //   .then((reportList: any[]) => {
        //     report.anyOf = reportList.map((d) => {
        //     return {
        //       type: "number",
        //       enum: [d.report.id],
        //       title: d.report.description || "",
        //     } as JSONSchema6;
        //     });
        //   });
        this.setState({ schema: newSchema2 });
      });
  }

  handleSubmit(e: ISubmitEvent<any>) {
    console.log("FormData report: ", e.formData);
    getApi()
      .report()
      .racesGeneral(e.formData)
      .then((blob) => {
        // const file = new Blob([blob], {
        //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // });

        const dateInit = this.fomatDate(e.formData.init);
        const dateEnd = this.fomatDate(e.formData.end);

        // const url = URL.createObjectURL(file);
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.setAttribute(
          "download",
          `Carreras_desde_${dateInit}_hasta_${dateEnd}.xls`
        );
        a.click();

        // window.open(url);
      });
  }

  fomatDate(date: any) {
    const dateFormatted = format(date, "DD MM YYYY");
    const dateChangeText = dateFormatted.split(" ").join("_");
    return dateChangeText;
  }

  render() {
    return (
      <Paper elevation={11} style={{ padding: 10 }}>
        <Grid container spacing={24}>
          <h2>Reporte de carreras</h2>
          <Grid item sm={12} md={12}>
            <EnhancedSchemaForm
              schema={this.state.schema}
              onSubmit={this.handleSubmit}
            >
              <div>
                <Button variant="contained" color="primary" type="submit">
                  Aceptar
                </Button>
              </div>
            </EnhancedSchemaForm>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: ReportProps) => ({
  ...ownProps,
  data: state.fcm,
});

const styled = withStyles(styles as any)(ReportsPage);
const connected = connect(mapStateToProps, bindActions(MessageActions))(styled);

export default connected as ComponentClass<Partial<ReportProps>>;



// WEBPACK FOOTER //
// ./src/pages/ReportsPage.tsx